import React from 'react';

export default function Popover({ label, title, content }) {
  return (
    <span className="popover-wrapper">
      <button type="button" className="btn btn-outline-secondary" style={{ margin: '0 2px' }}>
        <u>{label}</u>
      </button>
      <span className="popover-content">
        <strong style={{ display: 'block', marginBottom: '0.3rem' }}>{title}</strong>
        {content}
      </span>
    </span>
  );
}
